/* ==========================================================================
   PanelRoom > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'PanelRoom',
    init: true,
    events: true,
    start: true,
    type: {
        counter: 'panel-room-counter',
        adults: 'panel-room-adults',
        children: 'panel-room-children',
        age: 'panel-room-age',
        delete: 'panel-room-delete'
    },
    css: {
        self: 'panel-room',
        label: 'panel-room__label',
        options: 'panel-room__options',
        item: 'panel-room__item',
        age: 'panel-room__age',
        withTitle: 'with-title',
        children: 'is-children',
        delete: 'panel-room__delete'
    },
    hooks: {
        label: 'data-panel-room-label',
        ageSelectPanel: 'data-accomodation-options'
    }
};

module.exports = () => config;
